import { Breadcrumb, BreadcrumbItem } from '@carbon/react';
import type { LinkComponent } from '../../types';

export interface BreadcrumbEntry {
  label: string;
  href?: string;
}

export interface CdBreadcrumbsProps {
  items: BreadcrumbEntry[];
  /** Router link component (e.g. an adapter over React Router's Link). Defaults to `<a>`. */
  linkComponent?: LinkComponent;
  label?: string;
  className?: string;
}

/** The last item is rendered as the current page. */
export const CdBreadcrumbs = ({
  items,
  linkComponent: LinkEl,
  label = 'Breadcrumb',
  className,
}: CdBreadcrumbsProps) => {
  return (
    <Breadcrumb aria-label={label} noTrailingSlash className={className}>
      {items.map((item, index) => {
        const isCurrent = index === items.length - 1;
        if (isCurrent || !item.href) {
          return (
            <BreadcrumbItem key={item.label} isCurrentPage={isCurrent}>
              {item.label}
            </BreadcrumbItem>
          );
        }
        return LinkEl ? (
          <BreadcrumbItem key={item.label}>
            <LinkEl href={item.href}>{item.label}</LinkEl>
          </BreadcrumbItem>
        ) : (
          <BreadcrumbItem key={item.label} href={item.href}>
            {item.label}
          </BreadcrumbItem>
        );
      })}
    </Breadcrumb>
  );
};
